import React from 'react';
import { func } from 'prop-types';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import Print from '@alltrails/shared/icons/Print';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';

const CtaControls = ({ handlePrintClick }) => {
  if (handlePrintClick) {
    return (
      <IconButton
        icon={{ Component: Print }}
        onClick={wrapEventHandler(handlePrintClick)}
        title={StringConstantsMixin.strings.PRINT_MAP}
        testId="map-controls-print"
        variant="elevated"
      />
    );
  }
  return null;
};

CtaControls.propTypes = {
  handlePrintClick: func
};

CtaControls.defaultProps = {
  handlePrintClick: null
};

export default CtaControls;
